import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPaymentMethods: builder.query({
      query: ({PageNumber = 1, Take = 5}) => ({
        url: `/WebPaymentMethods/GetMethods`,
        method: "Get",
        params: {PageNumber, Take}
      }),
    }),
    addPaymentMethod: builder.mutation({
      query: (paymentData) => ({
        url: `/WebPaymentMethods/AddPaymentMethod`,
        method: "POST",
        body: paymentData,
      }),
    }),
    deletePaymentMethod: builder.mutation({
      query: ({id}) => ({
        url: `/WebPaymentMethods/Delete`,
        method: "POST",
        params: {id},
      }),
    }),
    setDefault: builder.mutation({
      query: ({id}) => ({
        url: `/WebPaymentMethods/MakeDefault`,
        method: "POST",
        body: {id},
      }),
    }),
  }),
});

export const { 
  useGetPaymentMethodsQuery,
  useAddPaymentMethodMutation,
  useDeletePaymentMethodMutation,
  useSetDefaultMutation
} = paymentApi;